import {
  AreaUnit,
  DealStatementTypes,
  EnteringInfoActionType,
  RegistrationTypes,
  RolesEnums,
  SubjectType
} from "./enums";

// select
export const registrationTypesSelect = [
  {key: RegistrationTypes.REGISTRATION_DKP, value: 'Регистрация ДКП'},
  {key: RegistrationTypes.REGISTRATION_SHARE, value: 'Регистрация ДДУ'},
  {key: RegistrationTypes.ADDITIONAL_STATEMENT, value: 'Дополнительное заявление'},
  {key: RegistrationTypes.PAYOFF_MORTGAGE_RECORD, value: 'Погашение записи об ипотеке в силу договора'},
  {key: RegistrationTypes.REG_ASSIGNMENT_AGREEMENT, value: 'Регистрация уступки'},
  {key: RegistrationTypes.MORTGAGE_REGISTRATION, value: 'Регистрация обременения'},
  {key: RegistrationTypes.REG_MORTGAGE_AGREEMENT, value: 'Регистрация ипотеки в силу договора (залога)'},
  {key: RegistrationTypes.REPAYMENT_MORTGAGE_REG_RECORD, value: 'Cнятие обременения'},
  {key: RegistrationTypes.MAKING_CHANGES_STATEMENT, value: 'Внесение изменений в запись ЕГРН'},
  {key: RegistrationTypes.ENTERING_INFORMATION_TO_EGRN, value: 'Внесение сведений в ЕГРН'},
  {key: RegistrationTypes.REG_RENT_AGREEMENT, value: 'Регистрация договора аренды'},
  {key: RegistrationTypes.REG_GKU_WO_RIGHT, value: 'Постановка на ГКУ без регистрации права'},
  {key: RegistrationTypes.REG_GKU_W_RIGHT, value: 'Постановка на ГКУ и регистрация прав'},
  {key: RegistrationTypes.TERMINATION_DKP, value: 'Расторжение ДКП'},
  {key: RegistrationTypes.CHANGE_SPECIFICATION_WO_RIGHT, value: 'Учет изменений без регистрации права'},
  {key: RegistrationTypes.REG_RIGHT, value: 'Регистрация права'},
  {key: RegistrationTypes.REG_SHARE_COMMON_PROPERTY, value: 'Регистрация права на долю в общедомовом имуществе'},
  {key: RegistrationTypes.REG_PREV_RIGHT_1998, value: 'Регистрация ранее возникшего (до 31.01.1998) права'},
  {key: RegistrationTypes.PROPERTY_DEREGISTRATION, value: 'Снятие с кадастрового учета объекта, права на который зарегистрированы в ЕГРН'},
  {key: RegistrationTypes.TERMINATION_OF_OWNERSHIP_RIGHTS, value: "Прекращение права собственности"}
];

// select
export const additionalStatementTypes = [
  {key: DealStatementTypes.ADDING_DOC_TO_REG, value: 'Внесение дополнительных документов к заявлению'},
  {key: DealStatementTypes.RETURN_WO_REG, value: 'Возврат документов без проведения регистрации'},
  {key: DealStatementTypes.SUSPEND_REG, value: 'Приостановление государственной регистрации'},
  {key: DealStatementTypes.RESUME_STATEMENT, value: 'Заявление о возобновлении'},
  {key: DealStatementTypes.MORTGAGE_REGISTRATION, value: 'Регистрация обременения'},
]

// select Тип действия по внесению данных в ЕГРН
export const enteringInfoActionType = [
  {key: EnteringInfoActionType.REGISTRY_CHANGE_ACTION, value: 'Внесение сведений в ЕГРН'},
  {key: EnteringInfoActionType.BORDER_ERROR_ACTION, value: 'Исправление технических ошибок в реестре границ'},
  {key: EnteringInfoActionType.REGISTRY_ERROR_ACTION, value: 'Исправление технических ошибок в ЕГРН'},
]

// select Тип договора -> в РР Код сделки (dealCode)
// выбор типа соглашения в уступке права
export const agreementTypesSelect = [
  {key: 'freeLoan', value: 'Безвозмездное пользование (ссуда)'},
  {key: 'concessionAgreement', value: 'Договор концессии'},
  {key: 'purchaseSaleAgreement', value: 'Договор купли-продажи'},
  {key: 'donationAgreement', value: 'Договор дарения'},
  {key: 'barterAgreement', value: 'Договор мены'},
  {key: 'rentAgreement', value: 'Договор ренты'},
  {key: 'lifelongMaintenDependent', value: 'Договор пожизненного содержания с иждивением'},
  {key: 'leaseAgreement', value: 'Договор аренды (субаренды)'},
  {key: 'freeUsePlotAgreement', value: 'Договор безвозмездного срочного  пользования земельным/лесным участком'},
  {key: 'mortgageAgreement', value: 'Договор об ипотеке (залоге)'},
  {key: 'residentLeaseAgreement', value: 'Договор найма жилого помещения'},
  {key: 'ventureConstructionAgreement', value: 'Договор участия в долевом строительстве'},
  {key: 'privatizationHousing', value: 'Передача жилья в собственность граждан (приватизация жилья)'},
  {key: 'repaitAgreement', value: 'Соглашение о восстановлении или поврежденного имущества'},
  {key: 'leaseAgreementAssign', value: 'Соглашение об уступке прав по договору аренды'},
  {key: 'agreementClaimsContract', value: 'Соглашение об уступке требований (переводе долга) по договору'},
  {key: 'changeTermsAgreement', value: 'Соглашение об изменении условий договора участия в долевом строительстве'},
  {key: 'terminateContractAgreement', value: 'Соглашение о расторжении договора'},
  {key: 'mortgageContractChangeAgreement', value: 'Соглашение об изменении содержания закладной'},
  {
    key: 'sharedConstructionClaimAgreement',
    value: 'Соглашение об уступке прав требования по договору участия в долевом строительстве'
  }
]

// select со снятием обременения
export const additionalStatementTypesWMortgage = additionalStatementTypes;

// Типы сделок
export const DealTypesMapping = {
  [RegistrationTypes.REGISTRATION_DKP]: 'Регистрация ДКП',
  [RegistrationTypes.MORTGAGE_REGISTRATION]: 'Регистрация обременения',
  [RegistrationTypes.REPAYMENT_MORTGAGE_REG_RECORD]: 'Регистрация снятия обременения',
  [RegistrationTypes.REG_MORTGAGE_AGREEMENT]: 'Регистрация ипотеки в силу договора (залога)',
  [RegistrationTypes.ADDITIONAL_STATEMENT]: 'Дополнительное заявление',
  [RegistrationTypes.MAKING_CHANGES_STATEMENT]: 'Внесение изменений',
  [RegistrationTypes.REG_ASSIGNMENT_AGREEMENT]: 'Регистрация уступки',
  [RegistrationTypes.ENTERING_INFORMATION_TO_EGRN]: 'Внесение сведений в ЕГРН',
  [RegistrationTypes.REGISTRATION_SHARE]: 'Регистрация ДДУ',
  [RegistrationTypes.REG_RENT_AGREEMENT]: 'Регистрация договора аренды',
  [RegistrationTypes.PAYOFF_MORTGAGE_RECORD]: 'Погасить ипотеку в силу договора',
  [RegistrationTypes.REG_GKU_WO_RIGHT]: 'Постановка на ГКУ без регистрации права',
  [RegistrationTypes.REG_GKU_W_RIGHT]: 'Постановка на ГКУ и регистрация прав',
  [RegistrationTypes.TERMINATION_DKP]: 'Расторжение ДКП',
  [RegistrationTypes.CHANGE_SPECIFICATION_WO_RIGHT]: 'Учет изменений',
  [RegistrationTypes.REG_SHARE_COMMON_PROPERTY]: 'Регистрация права на долю в общедомовом имуществе',
  [RegistrationTypes.REG_PREV_RIGHT_1998]: 'Регистрация ранее возникшего (до 31.01.1998) права',
  [RegistrationTypes.TERMINATION_OF_OWNERSHIP_RIGHTS]: 'Прекращение права собственности'
}

export const additionalStatementTypeTitleShort = {
  [DealStatementTypes.ADDING_DOC_TO_REG]: 'Внесение дополнительных документов к заявлению',
  [DealStatementTypes.RETURN_WO_REG]: 'Возврат документов без проведения регистрации',
  [DealStatementTypes.SUSPEND_REG]: 'Приостановление государственной регистрации',
  [DealStatementTypes.RESUME_STATEMENT]: 'Заявление о возобновлении государственной регистрации',
  [DealStatementTypes.MORTGAGE_REGISTRATION]: 'Регистрация обременения',
};

// Select типов документа
export const documentTypes = [
  {key: "otherDocs", value: "Иной документ"},
  {key: "attorney", value: "Доверенность"},
  {key: "purchaseSaleAgreement", value: "Договор купли-продажи"},
  {key: "spouseDealConsent", value: "Согласие супруга на совершение сделки"},
  {key: "marriageCert", value: "Свидетельство о заключении брака"},
  {key: "creditAgreement", value: "Кредитный договор"},
  {key: "birthCertificate", value: "Свидетельство о рождении"},
  {key: "marriageContract", value: "Брачный договор"},
  {key: "transferAct", value: "Передаточный акт"},
  {key: "leaseAgreement", value: "Договор аренды (субаренды)"},
  {key: "giftAgreement", value: "Договор дарения"},
  {key: "trustManagementAgreement", value: "Договор доверительного управления"},
  {key: "loanAgreement", value: "Договор займа"},
  {key: "mortgageAgreement", value: "Договор об ипотеке"},
  {key: "shareConstructionAgreement", value: "Договор участия в долевом строительстве"},
  {
    key: "supplementaryAgreement",
    value: "Дополнительное соглашение (соглашение об изменении условий договора) к договору"
  },
  {
    key: "statementRegistrationRestrictTransfer",
    value: "Заявление о регистрации права на недвижимое имущество, сделки с ним"
  },
  {
    key: "statementReIssueCertificate",
    value: "Заявление о повторной выдаче нового свидетельства о государственной регистрации права"
  },
  {
    key: "statementSuspensionRight",
    value: "Заявление о приостановлении регистрации прав на недвижимое имущество и сделок с ним"
  },
  {
    key: "statementSuspensionStateRegistration",
    value: "Заявление о приостановлении регистрации, возврате документов без проведения регистрации"
  },
  {key: "planLandManagment", value: "Карта (план) объекта землеустройства"},
  {key: "landBoundaryPlan", value: "Межевой план"},
  {key: "terminationContractAgreement", value: "Соглашение о расторжении договора"},
  {
    key: "assignmentRightClaimAgreement",
    value: "Соглашение об уступке прав требования по договору (договор о передаче прав и обязанностей)"
  },
  {
    key: "buildingTechPlan",
    value: "Технический план здания, сооружения, помещения либо объекта незавершённого строительства"
  }
];

/**
 * Сопоставление субтипов с типами документа
 * Пользователю выводим только подтипы документов
 * по подтипу определяем к какому типу относится документ.
 * @type
 */
export const mappingTypeSubtype = {
  marriageContract: "legalAct",
  attorney: "attorney",
  leaseAgreement: "legalAct",
  giftAgreement: "legalAct",
  trustManagementAgreement: "attorney",
  loanAgreement: "legalAct",
  purchaseSaleAgreement: "legalAct",
  mortgageAgreement: "legalAct",
  shareConstructionAgreement: "legalAct",
  mortgage: "other",
  statementRegistrationRestrictTransfer: "other",
  statementReIssueCertificate: "other",
  statementSuspensionRight: "other",
  statementSuspensionStateRegistration: "other",
  planLandManagment: "planDocument",
  creditAgreement: "legalAct",
  landBoundaryPlan: "planDocument",
  transferAct: "legalAct",
  marriageCert: "other",
  birthCertificate: "IDDocument",
  spouseDealConsent: "other",
  terminationContractAgreement: "legalAct",
  assignmentRightClaimAgreement: "legalAct",
  otherDocs: "other",
  buildingTechPlan: "planDocument",
  check: "paymentDocument",
  supplementaryAgreement: "legalAct",
};

export const realtyTypes = [
  {key: "flat", value: "Квартира, комната, помещение, апартаменты"},
  {key: "land", value: "Земельный участок"},
  {key: "building", value: "Строение, здание жилое / нежилое"},
  {key: "construction", value: "Сооружение"},
  {key: "underConstruction", value: "Объект незавершенного строительства"},
  {key: "parkingPlace", value: "Машино-место"},
  {key: "other", value: "Иное"},
]

export const realtyTypesMap = {
  flat: "Квартира",
  land: "Земельный участок",
  building: "Строение",
  construction: "Сооружение",
  underConstruction: "Объект незавершенного строительства",
  propertyComplex: "Предприятие как имущественный комплекс",
  parkingPlace: "Машино-место",
  other: "Иное",
}

export const AreaUnitTitleMap = {
  [AreaUnit.SQUARE_METER]: 'Кв.метр',
  [AreaUnit.HECTARE]: 'Гектар',
  [AreaUnit.SQUARE_MILLIMETER]: 'Кв.миллиметр',
  [AreaUnit.SQUARE_CENTIMETER]: 'Кв.сантиметр',
  [AreaUnit.SQUARE_DECIMETER]: 'Кв.дециметр',
  [AreaUnit.SQUARE_KILOMETER]: 'Кв.километр',
  [AreaUnit.THOUSAND_SQUARE_METERS]: 'Тысяча квадратных метров',
  [AreaUnit.ARE]: 'Ар (100 кв.м.)'
};

export const realtyAreaUnitSelect = Object.keys(AreaUnitTitleMap).map((key)=> ({key, value: AreaUnitTitleMap[key]}));

export const actionCodeTitle = {
  'regRealtyWithEGRN': "Постановка на государственный кадастровый учет и государственная регистрация прав в связи с созданием (образованием) объекта недвижимости (за исключением случаев ввода объекта капитального строительства в эксплуатацию, изъятия земельного участка на государственные нужды)",
  'removalFromCadastralReg': "Снятие с государственного кадастрового   учета объекта недвижимости, права на который зарегистрированы в ЕГРН",
  'cadastralRegOfPartRealty': "Постановка на государственный кадастровый учет части объекта недвижимости при регистрации ограничений и обременений права",
  'removalCadastralRegOfPartRealty': "Снятие с государственного кадастрового учета части объекта недвижимости при регистрации ограничений и обременений права",
  'regRealtyWOEGRN': "Государственная регистрация прав без одновременного государственного кадастрового учета (при наличии в ЕГРН сведений об объекте недвижимого имущества)",
  'terminateRealtyWoEGRN': "Государственная регистрация прекращения права на объект недвижимости бе з одновременного государственного кадастрового учета (при наличии в ЕГРН сведений об объект е недвижимого имущества)",
  'regTransferRightRealtyWoEGRN': "Регистрация перехода права на   объект недвижимости без одновременного государственного кадастрового учета (при наличии в ЕГРН сведений об объекте недвижимого имущества)",
  'regDealLimitationRight': "Регистрация сделки об ограничении (обременении) права (регистрация договора участия в долевом строительстве и регистрация договора аренды)",
  'regLimitationRight': "Регистрация ограничений прав на объект недвижимости и обременений объекта недвижимости",
  'terminateLimitationRight': "Прекращение ограничений прав на объект недвижимости и обременений объекта недвижимости",
  'resumeRegistration': 'Возобновление государственной регистрации, ранее приостановленной по заявлению правообладателя',
  'suspensionRegistration': 'Приостановление осуществления государственного кадастрового учета и (или) государственной регистрации прав в заявительном порядке',
  'terminateRegistration': 'Прекращение осуществления государственного кадастрового учета и (или) государственной регистрации прав в заявительном порядке',
  'submitAdditionalDocuments': 'Обработка дополнительных документов, представляемых заявителем, в том числе  с целью устранения причин, приведших к приостановлению государственного кадастрового учета и (или) государственной регистрации прав',
  'provisionEGRNData': "Предоставление сведений, содержащихся в Едином государственном реестр е недвижимости, посредством обеспечения доступа к федеральной государственной информационно й системе ведения Единого государственного реестра недвижимости",
  'provisionEGRNDataOwnership': "Предоставление сведений, содержащихся в ЕГРН, об объектах недвижимости и (или) и х правообладателях",
  'provisionEGRNDataDocCopy': "Предоставление сведений, содержащихся в ЕГРН, в виде копии документа",
  'makingChangesRightRecord': "Внесение изменений в записи реестра прав, ограничений прав и обременений недвижимого имущества Единого государственного реестра недвижимости",
  'enteringInformationToEGRN': 'Внесение сведений в ЕГРН по инициативе заинтересованного лица',
  'regGKUwRight': 'Постановка на государственный кадастровый учет и государственная регистрация прав в связи с созданием (образованием) объекта недвижимости (за исключением случаев ввода объекта капитального строительства в эксплуатацию, изъятия земельного участка на государственные нужды)',
  'regGKUwoRight': 'Постановка на государственный кадастровый учет объекта недвижимости без одновременной государственной регистрации прав (по разрешению на ввод в эксплуатацию ОКС,  в результате изъятия ЗУ или ОН на государственные нужды, при регистрации ЗУ, госсобственность на которые не разграничена, при регистрации мест общего пользования или ЗУ, занятых, объектам и незавершенного строительства, при постановке на учет квартир, помещений одновременно  с постановкой на КУ здания, если  право на здание зарегистрировано в ЕГРН)',
  'terminationDKP': 'Расторжение ДКП',
  'changeSpecificationWORight': 'Изменение основных характеристик объекта недвижимости без одновременной государственной регистрации прав',
  'regPrevRight1998': 'Регистрация ранее возникшего (до 31.01.1998) права'
}

export const rightKindSelect = [
  {key: "ownership", value: "Собственность"},
  {key: "sharedOwnership", value: "Общая долевая собственность"},
  {key: "coOwnership", value: "Общая совместная собственность"}
];

export const subjectTypeSelect = [
  {key: SubjectType.ORGANIZATION, value: "Юридическое лицо"},
  {key: SubjectType.PERSON, value: "Физическое лицо"},
]

export const subjectTypeReduced = {
  [SubjectType.ORGANIZATION]: "Юр. лицо",
  [SubjectType.PERSON]: "Физ. лицо",
}

export const IDDocumentTypes = [
  {key: 'passport', value: "Паспорт гражданина Российской Федерации"},
  {key: 'passportForeignCitizen', value: "Паспорт гражданина иностранного государства"},
  {key: 'birthCertificate', value: "Свидетельство о рождении"},
  {key: 'passportForeign', value: "Общегражданский заграничный паспорт"},
  {key: 'residencePermit', value: "Вид на жительство иностранного гражданина или лица без гражданства"},
  {key: 'otherID', value: "Иные документы удостоверяющие личность"},
  {key: '', value: "", disabled: true},
  {key: 'passportUSSR', value: "Паспорт гражданина СССР"},
  {key: 'passportForeignNavy', value: "Заграничный паспорт Министерства морского флота"},
  {key: 'passportDiplomacy', value: "Дипломатический паспорт"},
  {key: 'passportSeaman', value: "Паспорт моряка"},
  {key: 'passportMilitaryID', value: "Военный билет военнослужащего"},
  {key: 'passportMilitaryIDTemporary', value: "Военный билет военнослужащего временный"},
  {key: 'passportMilitaryOfficer', value: "Удостоверение личности офицера Министерства обороны"},
  {key: 'prisonReleaseCert', value: "Справка об освобождении из мест лишения свободы"},
  {key: 'tempId', value: "Временное удостоверение личности гражданина"},
  {key: 'relocaterID', value: "Удостоверение вынужденного переселенца"},
  {key: 'tempResidencePermit', value: "Разрешение на временное проживание в РФ"},
  {key: 'refugeeID', value: "Удостоверение беженца в Российской Федерации"}
]

export const Timezones = [
  {key: 'Europe/Kaliningrad', value: "(UTC +02) Калининград"},
  {key: 'Europe/Moscow', value: "(UTC +03) Волгоград, Киров, Москва"},
  {key: 'Europe/Samara', value: "(UTC +04) Самара, Саратов, Ульяновск"},
  {key: 'Asia/Yekaterinburg', value: "(UTC +05) Екатеринбург, Тюмень"},
  {key: 'Asia/Omsk', value: "(UTC +06) Омск"},
  {key: 'Asia/Barnaul', value: "(UTC +07) Барнаул, Красноярск, Новосибирск"},
  {key: 'Asia/Irkutsk', value: "(UTC +08) Иркутск"},
  {key: 'Asia/Yakutsk', value: "(UTC +09) Чита, Якутск"},
  {key: 'Asia/Vladivostok', value: "(UTC +10) Владивосток, Хабаровск"},
  {key: 'Asia/Magadan', value: "(UTC +11) Магадан, Сахалин"},
  {key: 'Asia/Kamchatka', value: "(UTC +12) Анадырь, Камчатка"},
]

export const RolesTitle = {
  [RolesEnums.BUYER]: 'Покупатели',
  [RolesEnums.REPRESENTATIVE]: 'Представители',
  [RolesEnums.SELLER]: 'Продавцы',
  [RolesEnums.DECLARANT]: 'Заявители',
  [RolesEnums.DEVELOPER]: 'Застройщик',
  [RolesEnums.SHAREHOLDER]: 'Дольщики',
  [RolesEnums.LANDLORD]: 'Арендодатели',
  [RolesEnums.RENTER]: 'Арендаторы',
  [RolesEnums.PLEDGEE]: 'Залогодержатели',
  [RolesEnums.PLEDGER]: 'Залогодатели',
  [RolesEnums.OWNER]: 'Собственники',
  [RolesEnums.EXT_SIGNER]: 'Внешние подписанты',
  [RolesEnums.NEW_OWNER]: 'Новый собственник',
  [RolesEnums.OLD_OWNER]: 'Старый собственник',
}

export const RolesTitleSingular = {
  [RolesEnums.BUYER]: 'Покупатель',
  [RolesEnums.REPRESENTATIVE]: 'Представитель',
  [RolesEnums.SELLER]: 'Продавец',
  [RolesEnums.DECLARANT]: 'Заявитель',
  [RolesEnums.DEVELOPER]: 'Застройщик',
  [RolesEnums.SHAREHOLDER]: 'Дольщик',
  [RolesEnums.LANDLORD]: 'Арендодатель',
  [RolesEnums.RENTER]: 'Арендатор',
  [RolesEnums.PLEDGEE]: 'Залогодержатель',
  [RolesEnums.PLEDGER]: 'Залогодатель',
  [RolesEnums.OWNER]: 'Собственник',
  [RolesEnums.EXT_SIGNER]: 'Внешний подписант',
  [RolesEnums.NEW_OWNER]: 'Новый собственник',
  [RolesEnums.OLD_OWNER]: 'Старый собственник',
}

export const StatusTitle = {
  'draft': 'Черновик',
  'documentsOnSign': 'Документы на подписании',
  'documentsSign': 'Документы подписаны',
  'dealSentToRR': 'Отправлена в Росреестр',
  'dealCompleted': 'Завершена', // Получено решение от РР
  'rosreestrProcessing': 'Принята в Росреестр', // Пройдены все проверки, квитанция оплачена
  'rosreestrQuitance': 'Сформирована квитанция', // Ожидание оплаты госпошлины
  'rosreestrPaid': 'Оплачено',
  'rosreestrInterrupted': 'Прекращено заявителем',
  'rosreestrSuspended': 'Приостановлено',
  'rosreestrValidationError': 'Ошибка проверки ФЛК', //
  'XMLReady': 'Сформировано заявление', // Ожидание оплаты госпошлины
}

export const exceptionsTitle = {
  VALIDATION_ERROR: 'Ошибка проверки формата значений',
  NO_XML_FILE_SIGN: 'Отсутствует подпись у XML файлов',
  DEAL_ALREADY_SENTTO_RR: 'Сделка отправлена в Росреестр, изменения не допустимы',
  DEAL_COMPLETED: 'Сделка завершена, изменения не допустимы',
  NO_STATEMENT_PACK_PATH: 'Внутреняя ошибка - отсутствует путь до пакета обращения',
  NO_DOCS_TO_SIGN: 'Не выбраны документы для подписания',
  SIGNME_SERVICE_UNAVAILABLE: 'Сервис подписания временно недоступен',
  NO_DEAL_STATEMENT_TYPE: 'Не указан типа заявления',
  AUTH_ERROR: 'Ошибка аутентификации пользователя.',
  INIT_HANDLE_FAIL: 'При отправке заявления на обработку в Росреестр возникла ошибка.',
  ROLE_ACCESS_DENY: 'Недостаточно прав. Обратитесь к администратору.',
  BRANCH_ACCESS_DENY: 'Доступ ограничен',
  DEAL_BRANCH_UNDEFINED: 'Отсутствует принадлежность сделки к поздразделению',
  USER_BRANCH_UNDEFINED: 'Пользователю не назначена принадлежность к подразделению',
  DELETE_DOCUMENT_ERROR: 'При удалении документа произошла ошибка',
  PARTICIPANT_UPDATE_ERROR: 'Ошибка сохранения данных участника сделки',
  NOT_ALL_DOCS_SIGNED: 'Не все документы подписаны',
  NOT_ALL_DOCS_HAVE_SIGNER: 'Не у всех документов указана принадлежность к заявителю.',
  NON_REJECT_DOC_ALREADY_SIGNED: 'Невозможно отозвать с подписи, документы уже подписаны',
  NO_SIGN_PROCESS_ID: 'Отсутствует ИД процесса подписания',
  NO_PHONE_NUMBER: 'Отсутствует номер телефона',
  NO_SNILS_NUMBER: 'Отсутствует номер СНИЛС',
  SIGNME_DELETE_REGISTRATION_ERROR: 'Ошибка удаления заявки на регистрацию',
  SIGNME_REGISTRATION_ERROR: 'Ошибка отправки заявки на регистрацию',
  SIGNME_ACTIVATE_ERROR: 'Ошибка подтверждения пользователя',
  SIGNME_UPLOAD_DOCS_ERROR: 'Ошибка загрузки документов в СайнМи',
  SIGNME_CHECK_REGISTRATION_ERROR: 'При запросе данных по регистрации в сайнми произошла ошибка',
  ValidationError: 'Ошибка проверки данных',
  ATTACHMENT_NOT_FOUND_IN_DOCUMENT: 'Изменено количество документов в сделке после формирования заявления. Сформируйте новое заявление.',
  UNKNOWN: 'Неизвестная ошибка',
  REQUIRED_DOCS_MISS: 'Отсутствуют обязательные документы для регистрации ЭЦП',
  INTERNAL_SIGNER_NOT_FOUND: 'Внутренний подписант не найден',
  VALIDATION_REPR_DOCUMENTS_ERROR: 'Ошибка назначения представителя',
  NO_SALE_CONTRACT: 'Отсутствует ДКП',
  NO_RENT_AGREEMENT: 'Отсутствует договор аренды',
  NO_RENT_AGREEMENT_DATE: 'Не указана дата договора аренды',
  NO_SHARE_CONSTRUCTION_AGREEMENT: 'Отсутствует договор участия в долевом строительстве',
  NO_SHARE_CONSTRUCTION_AGREEMENT_DATE: 'Отсутствует дата договора участия в долевом строительстве',
  FILTER_ERROR: 'Ошибка фильтрации данных',
  NO_REPRESENT_FOR_ORGANIZATION: 'Для юридического лица отсутствует представитель',
  NO_REG_UNIT_FOUND: 'Отсутствует адрес объекта',
  NO_ATTORNEY_DATE: 'Отсутствует дата доверенности представителя',
  NO_TERMINATION_DKP_CONTRACT: 'Отсутствует соглашение о расторжении ДКП',
  NO_TERMINATION_DKP_CONTRACT_DATE: 'Отсутствует дата соглашения о расторжении ДКП',
  NO_RIGHT_CLAIM_CONTRACT_DATE: 'Отсутствует дата соглашения об уступке прав требования по договору',
  NO_RIGHT_CLAIM_CONTRACT: 'Отсутствует соглашение об уступке прав требования по договору',
  NO_PARTICIPANT_IN_DEAL: 'В сделке отсутствуют заявители',
  CAD_NUM_NOT_VALID: 'Неправильно указан кадастровый номер',
  STATEMENT_CORRUPTED: 'В сделку внесены изменения после формирования заявления. Необходимо заново создаться заявление.',
  SIGNME_MAX_FILE_SIZE: "Файл превышает допустимый размер в 10Мб.",
  DISABLE_BANK_DRUZHBA_NOTIFICATIONS: "Создание уведомлений банка Дружба отключено",
  DISABLE_BANK_NOOSPHERA_NOTIFICATIONS: "Создание уведомлений банка Ноосфера отключено",
  DEAL_BLOCKED_FOR_SENTTO_RR: "Невозможно отправить сделку в Росреестр. Были внесены изменения после создания заявления.",
  GOSKEY_UNAVAILABLE: "Госключ временно недоступен",
  UPLOAD_ERROR: "Ошибка загрузки документа, повторите попытку позднее или обратитесь в техничекую поддержку",
  UPLOAD_LIMIT_ERROR:"Ошибка загрузки документа, привышен размер",
  SIGN_PROVIDER_UNDEFINED: "Не определен сервис подписания",
  DEAL_CANNOT_BE_DELETED: "Невозможно удалить сделку в текущем статусе",
  XML_DOWNLOAD_ERROR: "Ошибка скачивания XML-заявления. Повторите запрос позднее или обратитесь в Техподдержку.",
  XML_SIG_DOWNLOAD_ERROR: "Ошибка скачивания подписи XML-заявления. Повторите запрос позднее или обратитесь в Техподдержку.",
  VALIDATION_SHARE: "Некорректное распределение долей среди покупателей.",
  VALIDATION_BUYERS_SHARE: "Не у всех покупателей указана долевая или совместная собственность",
  PARTICIPANT_READ_ONLY: "Редактировать встроенного участника сделки запрещено.",
  DEAL_HAS_NOT_SENTTO_RR: "Сделка ещё не отправлена в Росреестр.",
  DEAL_GEN_XML_LOCKED: "Формирование пакета заявлений уже выполняется, дождитесь окончания.",
  NOT_ALLOWED_FILE_EXTENSION: "Недопустимое расширение файлов. Разрешены следующие форматы: 'pdf', 'jpg', 'xml', 'png', 'doc', 'txt', 'sig', 'zip'",
  NOT_ALLOWED_SIGNME_FILE_EXTENSION: "Недопустимое расширение файлов. Разрешены следующие форматы: 'pdf', 'jpg', 'png'",
  DEAL_MAX_FILE_SIZE: "Файл превышает максимально допустимый размер.",
  DEAL_ALREADY_PROCESSING: "Невозможно выполнить действие: сделка уже отправляется на регистрацию. Обновите страницу позднее.",
  MYDSS_APPLICATION_ID_NOT_FOUND: "Не найден ИД запроса.",
  MYDSS_BLANK_DOWNLOAD_ERROR: "Неудалось скачать бланк заявления, обратитесь в техподдержку.",
  MYDSS_USER_ALREADY_REGISTERED: "Пользователь уже зарегистрирован. Проверьте регистрацию.",
  MYDSS_NO_BLANK: "Бланк еще не создан в MyDSS.",
  MYDSS_UNAVAILABLE: "Сервис MyDSS недоступен"
}

export const errorsDescription = {
  CAD_NUM_ERROR: 'Кадастровый номер введен неправильно или не заполнен. Проверьте правильность внесения номера. Номер должен состоять из целых чисел и двоеточий, и соответствовать формату - 00:00:0000000:0000.',
  REALTY_SQUARE_ERROR: 'Площадь объекта введена некорректно. Проверьте правильность указания площади, допустимо использовать целые и дробные числа, разделенные точкой. Пример - 90 или 90.5',
  REALTY_COST_ERROR: 'Стоимость объекта введена некорректно. Проверьте правильность указания стоимости, допустимо использовать целые и дробные числа, разделенные точкой. Пример - 30000000 или 30000000.5',
  REALTY_FIAS_ADDR_ERROR: 'Адрес объекта недвижимости введен некорректно либо не найден в базе ФИАС. Введите адрес заново. Если точный адрес не найден, то введите район, населенный пункт, улицу, а также укажите в поле полный адрес по документам.',
  PERSON_ADDR_REGISTRATION: 'Адрес регистрации заявителя введен некорректно либо не найден в базе ФИАС. Если точный адрес не найден, то введите район, населенный пункт, улицу, а также укажите в поле полный адрес по документам.',
  PERSON_LAST_NAME: 'Фамилия заявителя введена некорректно или не заполнена. В фамилии допустимы только русские буквы, символы "-", пробелы и латинские цифры.',
  PERSON_FIRST_NAME: 'Имя заявителя введено некорректно или не заполнено. В имени допустимы только русские буквы, символы "-", пробелы и латинские цифры.',
  PERSON_MIDDLE_NAME: 'Отчество заявителя введено некорректно или не заполнено. В отчестве допустимы только русские буквы, символы "-", пробелы и латинские цифры.',
  PERSON_BIRTHDATE: 'Необходимо указать дату рождения.',
  PERSON_PHONE: 'Необходимо указать контактный номер телефона.',
  SNILS: "СНИЛС введен некорректно. Допустимо использовать пробелы, тире, числа или только числа. Длина не должна превышать 14 символов. Например, 123-456-789 00 или 12345678900.",
  INN: "ИНН введен некорректно. Допустимо использовать только числа. Проверьте правильность внесения номера.",
  RU_PASSPORT_SERIES: "Серия паспорта указана некорректно или не заполнена. Серия должна состоять из 4 цифр.",
  RU_PASSPORT_NUMBER: "Номер паспорта указан некорректно или не заполнен. Номер должен состоять из 6 цифр.",
  RU_PASSPORT_DIVISION_CODE: "Код подразделения указан некорректно или не заполнен. Код должен состоять из цифр, пробела или тире. Например, 722-000.",
  RU_PASSPORT_ISSUER: "Необходимо указать кто выдал паспорт.",
  PARTICIPANT_SHARE_INCORRECT: "Доля указана некорректно. Значение должно соответствовать формату ХХ/XX. Допустимо использовать символы косая черта и целые числа. Например, 1/2 или 1.",
  PARTICIPANT_SHAREDOWNERSHIP_INCORRECT: "При указании общей долевой собственности необходимо указать размер доли.",
  PARTICIPANT_REPRES_DOC_NOT_ATTACHED: "Документ подтверждающий полномочия представителя не прикреплен к заявителю. Перейдите в документ подтверждающий полномочия и прикрепите документ к заявителю.",
  PARTICIPANT_REPRES_DOC_NOT_SET: "При выборе представителя необходимо указать документ подтверждающий полномочия представителя.",
  PARTICIPANT_COMMON: "Данные заявителя заполнены некорректно.",
  DOCUMENT_NO_REF_TO_PARTICIPANT: "Документ не будет отправлен в Росреестр. Необходимо прикрепить документ к одному или нескольким заявителям."
}

export const infoTooltip = {
  UPLOAD_PRTICIPANT_SIGNATURE: 'Загрузить имеющуюся подпись клиента к документу.',
  DOWNLOAD_DOCUMENT_SIG: 'Скачать подпись документа',
  DOWNLOAD_DOCUMENT_WITH_FACSIMILIE: 'Скачать подписанный документ с факсимиле',
  EXT_SIGNER: 'Внешний подписант не является участником сделки, служит для подписания документов. Например, согласие на проведение сделки несовершеннолетним 14-18 лет.',
  SEND_TO_SIGN: 'Документ будет отправлен на подпись выбранным заявителям в списке выше.',
  ATTACH_DOC_TO_PARTICIPANT: 'Документ будет добавлен к заявлению участника сделки и передан в Росреестр.',
  INNER_SIGNER: 'Документ будет отправлен на подпись представителю банка.',
  OPEN_LINK_CUR_TAB: 'Открывать ссылки на страницы в текущей или новой вкладке. По умолчанию все ссылки открываются в новых вкладках.'
}

export const roleInfoMapping = {
  [RolesEnums.EXT_SIGNER]: infoTooltip.EXT_SIGNER
}

/**
 *
 * @type {{signme: string, goskey: string}}
 */
export const signProviderTitle = {
  signme: 'SignMe',
  goskey: 'Госключ'
}
